import React from "react";
import POData from "./POData";
import CreateNewPackingList from "./CreateNewPackingList";
import VEPackingListData from "./VEPackingListData";
import RAPackingList from "./RAPackingList";

export default function ReceiveInventoryTabs({
                                                 poSelected,
                                                 scannedData,
                                                 setScannedData,
                                                 activeTab,
                                                 setActiveTab
                                             }) {
    const tabs = [
        { id: "POData", label: "PO Information" },
        { id: "CreateNewPackingList", label: "Create New Packing List" },
        { id: "VEPackingListData", label: "View/Edit Packing List Data" },
        { id: "RAPackingList", label: "Receive Against Packing List" },
    ];

    return (
        <div>
            <div className="flex border-b">
                <div className="tabs-container">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`px-4 py-2 font-medium ${
                                activeTab === tab.id ? "border-b-2 border-indigo-500" : ""
                            }`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
            <div className="p-4">
                {activeTab === "POData" && <POData poSelected={poSelected}/>}
                {activeTab === "CreateNewPackingList" && <CreateNewPackingList poSelected={poSelected}/>}
                {activeTab === "VEPackingListData" && <VEPackingListData poSelected={poSelected}/>}
                {activeTab === "RAPackingList" &&
                    <RAPackingList
                        poSelected={poSelected}
                        scannedData={scannedData}
                        setScannedData={setScannedData}
                    />
                }
            </div>
        </div>
    );
}